// Archivo para centralizar la URL base de la API
const serviceUrl = process.env.REACT_APP_API_URL_INFORMES_DIARIOS;
const normalizedServiceUrl = serviceUrl ? serviceUrl.replace(/\/$/, '') : '';

const API_BASE_URL =
	process.env.REACT_APP_API_BASE_URL ||
	(normalizedServiceUrl ? `${normalizedServiceUrl}/api` : '/api');

export default API_BASE_URL;
